// Custom Functions:

import "./functions/fix-fullheight"; // Tweak for mobiles (full height)
import './functions/skip-link-focus-fix'; // mobile helper
import "./functions/to-top"; // To top button
//import "./functions/cases"; // cse studies page

// Browser detection
// import { browserDetect } from "./functions/browser-detect";
// console.log(browserDetect());

// Check OS on mobiles
// import { mobileCheck } from "./functions/mobile-check";
// console.log(mobileCheck())

// Vanilla JS implementation of jQuery methods
// import {slideUp, slideDown, slideToggle, fadeOut, fadeIn} from "./functions/slide-fade";

// Throttle helper function (usage example):
// let f = throttle(custom_function);
// window.addEventListener('resize', f);
